import { ReactElement } from 'react';

import styles from './NoDataFound.module.scss';
import Delayed from '../Delayed';

interface IProps {
  title?: string;
  waitBeforeShow?: number;
}

const NoDataFound = ({ title = 'No data found', waitBeforeShow = 0 }: IProps): ReactElement => (
  <Delayed waitBeforeShow={waitBeforeShow}>
    <div className={styles.noDataFound}>{title}</div>
  </Delayed>
);

export default NoDataFound;
